import { useMediaQuery } from '@mui/material';

const breakpoints = {
  xs: 0,      // Extra small devices (phones)
  sm: 600,    // Small devices (tablets)
  md: 900,    // Medium devices (small laptops)
  lg: 1200,   // Large devices (desktops)
  xl: 1536,   // Extra large devices (large desktops)
};

export const useBreakpoints = () => {
  const isMobile = useMediaQuery(`(max-width:${breakpoints.sm}px)`);
  const isTablet = useMediaQuery(`(min-width:${breakpoints.sm}px) and (max-width:${breakpoints.md}px)`);
  const isDesktop = useMediaQuery(`(min-width:${breakpoints.md}px)`);

  return {
    isMobile,
    isTablet,
    isDesktop,
    breakpoints,
  };
};

export default useBreakpoints; 